// ABOUTME: Renders a "status changed to X" activity pill for a chat update.
// ABOUTME: Green gradient pill with the new status displayed in a chip on the right.

import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Text from "../../../../../../../components/theme/text/Text";
import { tokens } from "../../../../../../../theme";

const MessageTypeStatusChange = ({ update }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box
            sx={{
                height: 40,
                borderRadius: 5,
                background: `linear-gradient(to right, ${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0]} -15%, ${colors.green[200]} 150%), ${theme.palette.mode === "dark" ? "black" : "white"}`,
                border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}`,
                pr: 0.5,
                pl: 2,
                display: "flex",
                alignItems: 'center',
                justifyContent: "space-between",
                gap: 1.5,
            }}
        >
            <Text noBreak fontSize={13}>{t("status_updated_to")}</Text>
            <Box
                sx={{
                    flexShrink: 0,
                    height: 32,
                    px: 2,
                    borderRadius: 4,
                    background: colors.green[100],
                    lineHeight: "32px",
                }}
            >
                <Text bold variant="green">{t(update.newStatus)}</Text>
            </Box>
        </Box>
    );
};

export default MessageTypeStatusChange;
